export default {
    LOAD_GUEST_SCHEDULES(state, guest_schedule) {
        state.items = guest_schedule;
    }
}